import moment from 'moment';
import React from 'react';

const AGE_INPUT_FORMATS = [moment.ISO_8601, 'YYYY-MM-DD'];

export interface IProps {
  fallback: React.ReactNode;
  value: moment.MomentInput;
}

class AgeLabel extends React.Component<IProps> {
  static defaultProps = { fallback: '' };

  private parseValue(value: moment.MomentInput) {
    if (typeof value === 'string') {
      return moment(value, AGE_INPUT_FORMATS, true);
    }
    return moment(value);
  }

  private formatAge(value: moment.MomentInput): string | null {
    const parsed = this.parseValue(value);

    if (!parsed.isValid() || parsed.year() <= 1) {
      return null;
    }

    const years = moment().diff(parsed.startOf('day'), 'years');
    return `${years} year${years === 1 ? '' : 's'} old`;
  }

  render() {
    const { fallback, value } = this.props;

    if (value == null) return <span>{fallback}</span>;

    const content = this.formatAge(value) ?? fallback;

    return <span>{content}</span>;
  }
}

export default AgeLabel;
